<template>

  <a-spin :spinning="confirmLoading">
    <div>
      <a-form :form="form" slot="detail">
        <div class="Section0" style="layout-grid:15.6000pt;">
          <p class=MsoNormal align=center style="text-align:center;"><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:'Times New Roman';
mso-bidi-font-family:'Times New Roman';mso-ansi-font-weight:bold;font-size:18.0000pt;
mso-font-kerning:1.0000pt;"><font face="黑体">山东师范大学招标采购项目{{fuyan.title}}</font></span></b><b
            style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:'Times New Roman';
mso-bidi-font-family:'Times New Roman';mso-ansi-font-weight:bold;font-size:18.0000pt;
mso-font-kerning:1.0000pt;"> </span></b></p>
          <p style="display: inline;padding: 70px;"><font color="red">{{SignCompleteText}}</font></p>
          <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:'Times New Roman';mso-fareast-font-family:宋体;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">  </span></p>
          <div align=center>
            <table class=MsoNormalTable border=1 cellspacing=0 style="border-collapse:collapse;width:483.6000pt;border:none;
mso-border-left-alt:0.5000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;mso-border-insideh:0.5000pt solid windowtext;mso-border-insidev:0.5000pt solid windowtext;
mso-padding-alt:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;">
              <tr style="height:30.7500pt;">
                <td width=132 valign=center colspan=2 style="width:99.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;"><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"><font face="宋体">项目名称</font></span><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"> </span></p>
                </td>
                <td width=512 valign=center colspan=3 style="width:384.3500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                    {{model.budgetAddmainName}}
                </td>
              </tr>
              <tr style="height:30.7500pt;">
                <td width=132 valign=center colspan=2 style="width:99.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;"><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"><font face="宋体">项目编号</font></span><b style="mso-bidi-font-weight:normal"><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';mso-ansi-font-weight:bold;
font-size:12.0000pt;mso-font-kerning:1.0000pt;"> </span></b></p>
                </td>
                <td width=165 valign=center style="width:124.3000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;"><b style="mso-bidi-font-weight:normal"><span
                    style="font-family:黑体;mso-hansi-font-family:宋体;mso-bidi-font-family:Arial;
mso-ansi-font-weight:bold;font-size:12.0000pt;mso-font-kerning:1.0000pt;"> {{model.budgetAddmainCode}}</span></b></p>
                </td>
                <td width=132 valign=center style="width:99.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;"><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"><font face="宋体">合同编号</font></span><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:12.0000pt;
mso-font-kerning:1.0000pt;"> </span></p>
                </td>
                <td width=214 valign=center style="width:160.8000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;"><b style="mso-bidi-font-weight:normal"><span
                    style="font-family:黑体;mso-hansi-font-family:宋体;mso-bidi-font-family:Arial;
mso-ansi-font-weight:bold;font-size:12.0000pt;mso-font-kerning:1.0000pt;">
                      {{model.contractNo}}
                      </span></b></p>
                </td>
              </tr>

              <tr style="height:30.7500pt;">
                <td width=132 valign=center colspan=2 style="width:99.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;"><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"><font face="宋体">中标单位</font></span><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"> </span></p>
                </td>
                <td width=165 valign=center style="width:124.3000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;"><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
                      {{model.zbdw}}
                  </span></p>
                </td>
                <td width=132 valign=center style="width:99.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;"><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"><font face="宋体">合同金额</font></span><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"> </span></p>
                </td>
                <td width=214 valign=center style="width:160.8000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;"><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
                    <a-form-item style="margin: 0 !important;" label="">
<!--              <a-input  class="shurukuang"  v-decorator="['zbPrice']" placeholder="合同金额" disabled></a-input>-->
              {{model.zbPrice}}(本次验收金额:{{model.ysMoney}})
            </a-form-item>
                  </span></p>
                </td>
              </tr>
              <tr style="height:45.0000pt;">
                <td width=132 valign=center colspan=2 style="width:99.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;line-height:20.0000pt;mso-line-height-rule:exactly;"><span
                    style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"><font face="宋体"><font style="color:red">*</font>中标方项目负责人签字</font></span><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:12.0000pt;
mso-font-kerning:1.0000pt;"> </span></p>
                </td>
                <td width=165 valign=center style="width:124.3000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;"><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
                      {{model.zbdwfzrName}}
                    </span></p>
                </td>
                <td width=132 valign=center style="width:99.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;"><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"><font face="宋体"><font style="color:red">*</font>联系方式</font></span><span style="font-family:Arial;mso-fareast-font-family:宋体;font-size:12.0000pt;
mso-font-kerning:1.0000pt;"> </span></p>
                </td>
                <td width=214 valign=center style="width:160.8000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;"><span style="font-family:Arial;mso-fareast-font-family:宋体;font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
                      {{model.zbdwfzrPhone}}</span></p>
                </td>
              </tr>
              <tr style="height:40.7500pt;">
                <td width=132 valign=center colspan=2 style="width:99.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;"><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"><font face="宋体"><font style="color:red">*</font>完工时间</font></span><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:12.0000pt;
mso-font-kerning:1.0000pt;"> </span></p>
                </td>
                <td width=165 valign=center style="width:124.3000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                   <span style="font-family:Arial;mso-fareast-font-family:宋体;font-size:12.0000pt;mso-font-kerning:1.0000pt;">
                       {{model.projectFinishtime}}
                    </span>
                </td>
                <td width=132 valign=center style="width:99.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;line-height:20.0000pt;mso-line-height-rule:exactly;"><span
                    style="font-family:Arial;mso-fareast-font-family:宋体;mso-hansi-font-family:'Times New Roman';
font-size:12.0000pt;mso-font-kerning:1.0000pt;"><font face="宋体">提出验收</font></span><span style="font-family:Arial;mso-fareast-font-family:宋体;mso-hansi-font-family:'Times New Roman';
font-size:12.0000pt;mso-font-kerning:1.0000pt;"> </span></p>
                  <p class=MsoNormal align=center style="text-align:center;line-height:20.0000pt;mso-line-height-rule:exactly;"><span
                    style="font-family:Arial;mso-fareast-font-family:宋体;mso-hansi-font-family:'Times New Roman';
font-size:12.0000pt;mso-font-kerning:1.0000pt;"><font face="宋体">申请时间</font></span><span style="font-family:Arial;mso-fareast-font-family:宋体;mso-hansi-font-family:'Times New Roman';
font-size:12.0000pt;mso-font-kerning:1.0000pt;"></span></p>
                </td>
                <td width=214 valign=center style="width:160.8000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;">
                    <span style="font-family:Arial;mso-fareast-font-family:宋体;font-size:12.0000pt;mso-font-kerning:1.0000pt;">
                        {{model.createTime}}
                    </span>
                  </p>
                </td>
              </tr>
              <tr style="height:43.4000pt;">
                <td width=132 valign=center colspan=2 style="width:99.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;line-height:20.0000pt;mso-line-height-rule:exactly;"><span
                    style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"><font face="宋体"><font style="color:red">*</font>项目类别</font></span><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:12.0000pt;
mso-font-kerning:1.0000pt;"> </span></p>
                </td>
                <td width=165 valign=center style="width:124.3000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;"><span>
                                          {{model.projectType}}

                  </span></p>
                </td>
                <td width=132 valign=center style="width:99.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;line-height:20.0000pt;mso-line-height-rule:exactly;"><span
                    style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"><font face="宋体"><font style="color:red">*</font>中标合同是否有变更情况</font></span><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"> </span></p>

                </td>
                <td width=214 valign=center style="width:160.8000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;"><span style="font-family:Arial;mso-fareast-font-family:宋体;font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
                      {{model.hasBght=="0"?"否":"是"}}
                  </span></p>
                </td>
              </tr>
              <tr style="height:29.6500pt;" v-if="hasBght=='1'">
                <td width=132 valign=center colspan=2 style="width:99.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;"><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"><font face="宋体"><font style="color:red">*</font>变更申请表</font></span><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"> </span></p>
                </td>
                <td width=512 valign=center colspan=3 style="width:384.3500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
<!--                  <a-form-item style="margin: 0 !important;" label="">-->
<!--                    <a style="color:red" v-if="yscbgsq==''">如有合同变更,请上传变更申请表</a>-->
<!--                    <j-upload v-decorator="['bgsqb',validatorRules.bgsqb]" @change="yscbgsq='1'" :trigger-change="true" ></j-upload>-->
<!--                  </a-form-item>-->
                </td>
              </tr>
              <tr style="height:39.6500pt;">
                <td width=132 valign=center colspan=2 style="width:99.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;"><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"><font face="宋体">其他需要说明的问题</font></span><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"> </span></p>
                </td>
                <td width=512 valign=center colspan=3 style="width:384.3500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                    {{model.otherRemarks}}
                </td>
              </tr>
              <tr style="height:42.3000pt;">
                <td width=644 valign=center colspan=5 style="width:483.6000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;"><span style="font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';
mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><font
                    face="宋体">以上项目由</font></span><b style="mso-bidi-font-weight:normal"><i
                    style="mso-bidi-font-style:normal"><span style="font-family:黑体;mso-bidi-font-family:'Times New Roman';mso-ansi-font-weight:bold;
mso-ansi-font-style:italic;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><font face="黑体">中标单位或项目执行单位</font></span></i></b><span
                    style="font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';
mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><font face="宋体">填写，</font></span><b
                    style="mso-bidi-font-weight:normal"><i style="mso-bidi-font-style:normal"><span style="font-family:黑体;mso-bidi-font-family:'Times New Roman';mso-ansi-font-weight:bold;
mso-ansi-font-style:italic;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><font
                    face="黑体">设备、家具类</font></span></i></b><span style="font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';
mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><font
                    face="宋体">采购项目并附上</font></span><b style="mso-bidi-font-weight:normal"><i style="mso-bidi-font-style:normal"><span
                    style="font-family:黑体;mso-bidi-font-family:'Times New Roman';mso-ansi-font-weight:bold;
mso-ansi-font-style:italic;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><font
                    face="黑体">货物验收清单</font></span></i></b><span style="font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';
mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><font
                    face="宋体">，</font></span><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:12.0000pt;
mso-font-kerning:1.0000pt;"> </span></p>
                  <p class=MsoNormal align=center style="text-align:center;"><b style="mso-bidi-font-weight:normal"><i
                    style="mso-bidi-font-style:normal"><span style="font-family:黑体;mso-bidi-font-family:'Times New Roman';mso-ansi-font-weight:bold;
mso-ansi-font-style:italic;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><font
                    face="黑体">工程类</font></span></i></b><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:12.0000pt;
mso-font-kerning:1.0000pt;"><font face="宋体">项目附上</font></span><b style="mso-bidi-font-weight:normal"><i
                    style="mso-bidi-font-style:normal"><span style="font-family:黑体;mso-bidi-font-family:'Times New Roman';mso-ansi-font-weight:bold;
mso-ansi-font-style:italic;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><font face="黑体">工程量清单</font></span></i></b><i
                    style="mso-bidi-font-style:normal"><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;mso-ansi-font-style:italic;
font-size:12.0000pt;mso-font-kerning:1.0000pt;"> </span></i></p>

<!--                  <a-form-item style="margin: 0 !important;" label="附件：">-->
<!--                    <j-upload  v-decorator="model.projectType!=null&&model.projectType!='服务'?['shqdFile',validatorRules.shqdFile]:['shqdFile']"-->
<!--                              style="margin-bottom:10px" @change="" :trigger-change="true" ></j-upload>-->
<!--                  </a-form-item>-->
                  <p>
<!--                      <a href="/山东师范大学货物验收清单.xlsx">点击下载《山东师范大学货物验收清单模板》</a>-->
                  </p>
                </td>
              </tr>
              <tr style="height:38.9000pt;">
                <td width=109 valign=center style="width:81.8000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;"><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"><font style="color:red" v-if="projectType=='工程'">*</font><font face="宋体">工程监理</font></span><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"> </span></p>
                  <p class=MsoNormal align=center style="text-align:center;"><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"><font face="宋体">意见</font></span><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:14.0000pt;
mso-font-kerning:1.0000pt;"> </span></p>
                </td>
                <td width=535 valign=top colspan=4 style="width:401.8000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;line-height:18.0000pt;mso-line-height-rule:exactly;"><span
                    style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">  </span></p>
                  <p class=MsoNormal align=justify style="text-align:justify;text-justify:inter-ideograph;line-height:18.0000pt;
mso-line-height-rule:exactly;"><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;">  </span></p>
                  <p class=MsoNormal align=justify style="text-align:justify;text-justify:inter-ideograph;line-height:18.0000pt;
mso-line-height-rule:exactly;">


                  <span v-if="sqputong_jiandu.showQrCodediv && genQcode && projectType=='工程'">
                     <a-button style="margin-top:10px" type="primary" @click="QrCode_shenqing(sqputong_jiandu)">生成二维码,请扫码签字</a-button>
                    <QrCode
                      :visible="sqputong_jiandu.showQrCode"
                      :id="'QrCode'"
                      :title="sqputong_jiandu.qrtitle"
                      :text='sqputong_jiandu.qrtext'
                      @onClose="()=>sqputong_jiandu.showQrCode=false"/>
                  </span>
                  </p>
                  <p>{{sqputong_jiandu.msg}}</p>
                  <div style="margin-top:10px;font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;display:flex;
mso-font-kerning:1.0000pt;text-align:left"><font face="宋体" style="width:100px" >监理签字：</font>
                    <div class="image-container" v-for="(item,i) in sqputong_jiandu.img">
                      <img   :src="item.elSign" style="width:180px"/>
                    </div>
</div><span style="margin-top:10px;display:flex;font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"><span style="font-family:宋体;mso-spacerun:'yes';">
</span><font
                    face="宋体" style="width:100px">联系方式：</font>
                   {{sqputong_jiandu.phone}}
                </span><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"> </span></p>

                </td>
              </tr>
              <tr style="height:162.5000pt;">
                <td width=109 valign=center style="width:81.8000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;"><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><font face="宋体">项目执行单位初步验收意见</font></span><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"> </span></p>
                </td>
                <td width=535 valign=top colspan=4 style="width:401.8000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <a-form-item style="margin: 0 !important;" label="">
                      {{model.projectOpinion}}
                  </a-form-item>
                  <p class=MsoNormal align=justify style="text-align:justify;text-justify:inter-ideograph;line-height:18.0000pt;
mso-line-height-rule:exactly;"><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"><font face="宋体">初验人员</font><font face="宋体">(</font></span><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"><font face="宋体">需三人</font>)</span><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"><font face="宋体">签字：</font>
                    <span v-if="sqputong_chubuyanshou.showQrCodediv && genQcode">

                  </span>
                       <div class="image-container" v-for="(item,i) in sqputong_chubuyanshou.img">
                      <img   :src="item.elSign" style="width:180px"/>
                   </div>
                  </span><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"><br></span><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"> </span></p>
                  <p class=MsoNormal align=justify style="text-align:justify;text-justify:inter-ideograph;line-height:18.0000pt;
mso-line-height-rule:exactly;"><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;">  </span></p>
                  <p class=MsoNormal align=justify style="text-align:justify;text-justify:inter-ideograph;line-height:18.0000pt;
mso-line-height-rule:exactly;"><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"><font face="宋体">项目负责人签字：</font>
                  <span v-if="sqputong_chubuyanshouFuZheRen.showQrCodediv && genQcode">
                     <a-button type="primary"  @click="QrCode_shenqing(sqputong_chubuyanshouFuZheRen)">生成二维码,请扫码签字</a-button>
                    <QrCode
                      :visible="sqputong_chubuyanshouFuZheRen.showQrCode"
                      :id="'QrCodecyFuzheren'"
                      :title="sqputong_chubuyanshouFuZheRen.qrtitle"
                      :text='sqputong_chubuyanshouFuZheRen.qrtext'
                      @onClose="()=>sqputong_chubuyanshouFuZheRen.showQrCode=false"/>
                  </span>
                    <div class="image-container" v-for="(item,i) in sqputong_chubuyanshouFuZheRen.img">
                      <img   :src="item.elSign" style="width:180px"/>
                   </div>
                    <!--                                        <a-form-item style="margin: 0 !important;" label="">-->
<!--                      <a-input  class="shurukuang"  v-decorator="['xmfzrName']"  style="width:150px" disabled></a-input>-->
<!--                                        </a-form-item>-->
<span style="font-family:宋体;mso-spacerun:'yes';"></span><font
                    face="宋体">联系方式：{{sqputong_chubuyanshouFuZheRen.phone}}</font>
<!--                                        <a-form-item style="margin: 0 !important;" label="">-->
<!--                    <a-input  class="shurukuang"  v-decorator="['xmfzrPhone']"  style="width:100px" ></a-input>-->
<!--                                        </a-form-item>-->
</span><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"> </span></p>
                  <p class=MsoNormal align=justify style="text-align:justify;text-justify:inter-ideograph;line-height:18.0000pt;
mso-line-height-rule:exactly;"><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"></span></p>
                  <p class=MsoNormal align=justify style="text-align:justify;text-justify:inter-ideograph;line-height:18.0000pt;
mso-line-height-rule:exactly;"><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"><font face="宋体">单位负责人（签字）：</font>

                     </span>
                  <p class=MsoNormal style="margin-left:60px;"><font
                  face="宋体">{{dwfzrqz}}</font></p>
                  <p class=MsoNormal style="margin-left:120px;margin-top:10px;">
                    <font
                    face="宋体">{{dwfzrqzsj}}</font></p>

                  </p>

                  <p class=MsoNormal align=center style="text-align:center;line-height:18.0000pt;mso-line-height-rule:exactly;"><span
                    style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">  </span></p>
                </td>
              </tr>
              <tr style="height:49.1500pt;">
                <td width=109 valign=center style="width:81.8000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;"><span style="font-family:宋体;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;"><font face="宋体">备注</font></span><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:12.0000pt;
mso-font-kerning:1.0000pt;"> </span></p>
                </td>
                <td width=535 valign=top colspan=4 style="width:401.8000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                  <p class=MsoNormal align=center style="text-align:center;">
                      <span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
                      {{model.yssqRemarks}}
                       </span>
                  </p>
                </td>
              </tr>
            </table>
          </div>
          <p class=MsoNormal align=center style="text-align:center;line-height:18.0000pt;mso-line-height-rule:exactly;"><span
            style="mso-spacerun:'yes';font-family:方正小标宋简体;mso-hansi-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="方正小标宋简体">注：本表只需一份，由项目执行单位填写初步验收意见后，交至资产与实验室管理处履约验收科<p>（文化楼127室,电话86180711/文昌楼350室,86180710）。<p></p></font></span><span style="mso-spacerun:'yes';font-family:方正小标宋简体;mso-hansi-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"> </span></p>
        </div>
      </a-form>
    </div>
  </a-spin>
</template>

<script>

  import {httpAction, getAction} from '@/api/manage'
  import pick from 'lodash.pick'
  import moment from 'moment'
  import dayjs from 'dayjs';
  export default {
    name: 'UapsBudgetAddmainForm',
    components: {

    },
    props: {
      genQcode:{
        type:Boolean,
        default:false
      },
      //流程表单data
      formData: {
        type: Object,
        default: () => {
        },
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data() {
      return {
        showQrCode:false,
        qrcodeText:'',
        qrcodeTitle:'',
        yanshou: {},
        yanshouOptions: [{value: '1', label: '自行验收'}, {value: '2', label: '委托验收'}],
        form: this.$form.createForm(this),
        model: {},
        yscbgsq:'',
        dwfzrqz:'',
        dwfzrqzsj:'',
        projectType:'',
        hasBght:'',
        labelCol: {
          xs: {span: 24},
          sm: {span: 5},
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16},
        },
        confirmLoading: false,
        packageId: '',
        fileIds: '',
        tableId: '',
        orgCode:'',
        accId:'0',
        planId:'',
        flowTitle:'履约验收审核',//流程title
        SignCompleteText:'',//未完成签名提示信息
        isSave:false,//是否保存数据
        fuyan:{
          isFuyan:false,
          title:"验收申请"
        },
        contractTime:null,//合同签订日期
        domain:window.location.host,
        //工程监理意见
        sqputong_jiandu:{
            name:[],
            nameNum:1,//签名个数
            msg:"",
            phone:"",
            yijian:"",
            qrtitle:"工程监理意见签字",
            qrtext:"",
            field:"sqputong_jiandu",
            showQrCodediv:true,
            showQrCode:false,
            createTime:null,
             img:[]
        },
        //项目执行单位初步验收意见 初验人员(需三人)签字
        sqputong_chubuyanshou:{
          name:[],
          nameNum:3,//签名个数
          phone:"",
          msg:"",
          qrtitle:"初验人员签字",
          qrtext:"",
          field:"sqputong_chuyan",
          showQrCodediv:true,
          showQrCode:false,
          createTime:null,
          img:[]
        },
        //项目执行单位初步验收意见 项目负责人签字
        sqputong_chubuyanshouFuZheRen:{
          name:[],
          nameNum:1,//签名个数
          phone:"",
          msg:"",
          qrtitle:"项目负责人签字",
          qrtext:"",
          field:"sqputong_chuyanFuZheRen",
          showQrCodediv:true,
          showQrCode:false,
          createTime:null,
          img:[]
        },
        //项目执行单位初步验收意见 单位负责人签字
        sqputong_cyDanWeiFuZheRen:{
          name:[],
          nameNum:1,//签名个数
          phone:"",
          msg:"",
          qrtitle:"单位负责人签字",
          qrtext:"",
          field:"sqputong_chuyanDanWeiFuZheRen",
          showQrCodediv:false,
          //showQrCodediv:true,
          showQrCode:false,
          createTime:null,
          img:[]
        },
        yssqEndTime:'',
        validatorRules: {
          zbdwfzrName: {
            rules: [
              {required: true, message: '请输入中标方负责人姓名'},
            ]
          },
          zbdwfzrPhone: {
            rules: [
              {required: true, message: '请输入中标方联系方式'},
            ]
          },
          acceptanceETime: {
            rules: [
              {required: true, message: '请选择完工时间'},
            ]
          },
          hasBght: {
            rules: [
              {required: true, message: '请选择中标合同是否有变更情况'},
            ]
          },
          hasImport: {
            rules: [
              {required: true, message: '请选择有无进出口设备'},
            ]
          },
          bgsqb: {
            rules: [
              {required: true, message: '请上传变更申请表'},
            ]
          },
          shqdFile: {
            rules: [
              {required: true, message: '请在附件处上传工程量清单/货物验收清单'},
            ]
          },
        },
        url: {
          add: "/uaps_project_acceptance/uapsProjectAcceptance/add2",
          edit: "/uaps_project_acceptance/uapsProjectAcceptance/edit",
          queryById: "/uaps_budget_addmain/uapsBudgetAddmain/queryById"
        }
      }
    },
    computed: {
      formDisabled() {
        if (this.formBpm === true) {
          if (this.formData.disabled === false) {
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton() {
        if (this.formBpm === true) {
          if (this.formData.disabled === false) {
            return true
          }
        }
        return false
      }
    },
    created() {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();

      //通过扫码方式显示数据
        let that=this;
        setTimeout(function() {
          that.getDataById();
        },500);
    },
    methods: {
      //上传货物清单事件
      uploadFile(){
        this.yscbgsq='1';
      },
      getSignImg: function (avatar) {
        if(avatar.name.length>0){
          return getFileAccessHttpUrl(avatar.name[0].sign);
        }
        return null;
      },
      getGZImg: function (avatar) {
        if(avatar.name.length>0){
          return {background: 'url(' + getFileAccessHttpUrl(avatar.name[0].GZ) + ')  65% -3% / 150px no-repeat',height:'160px'};
        }
        return null;
      },
      getSignTime: function (avatar) {
        if(avatar.name.length>0){
          return avatar.name[0].time;
        }
        return null;
      },
      disabledWangongDate(val){
        //完工日期 限制
        let contractBjTime=moment(this.contractTime).format('YYYY-MM-DD');
        // return val < moment(contractBjTime, 'YYYY-MM-DD').add(-1, 'days').endOf('day')
        return val >= moment().add(1, 'days').startOf('day')
      },
      // 导出word方法
      exportWordFile() {
        let params = {
          planId : this.planId,packageId:this.packageId,id:this.tableId,fuyan:this.fuyan.isFuyan,orgCode:this.orgCode
        };
        downloadFile('/uaps_project_acceptance/uapsProjectAcceptance/exportWord', "山东师范大学招标采购项目"+this.fuyan.title+".docx",params);
      },
      //生成二维码
      QrCode_shenqing(obj){
        //已经保存过数据，直接生成二维码
        if(this.isSave){
          let qrcodetxt='/expertConfirmInfo?infoType=apply&accId='+this.accId+'&orgCode='+this.orgCode+'&planId='+this.planId+'&packageId='+this.packageId+'&id='+this.tableId+'&field='+obj.field;
          let time = parseInt(new Date().getTime() / 1000);
          obj.qrtext='http://'+this.domain+qrcodetxt+'&time='+time;
          obj.showQrCode=true;
        }
        else{
          // 触发表单验证,数据项必须填写完整，才能生成二维码，否则查看二维码信息内容为空
          const that = this;
          this.form.validateFields((err, values) => {
            if (!err) {
              var datee = new Date();
              var projectFinishtime = Date.parse(values.projectFinishtime);
              if(datee<=projectFinishtime){
                this.$message.error("完工日期不能超过当天时间");
                return;
              }
              that.confirmLoading = true;
              let httpurl = '';
              let method = '';
              httpurl += that.url.add;
              method = 'post';
              let formData = Object.assign(that.model, values);
              formData.packageNo = that.packageId;
              formData.isBa='0'
              if(formData.ysxzIdea=="2" || formData.ysxzIdea=="3"){
                formData.ysxzIdea=null;
                formData.createTime=null;
                formData.ysxzObjection=null;
              }
              formData.id=that.accId;
              httpAction(httpurl, formData, method).then((res) => {
                if (!res.success) {
                  let msg=res.message;
                  let msgArray=msg.split(',');
                  that.accId=msgArray[1];
                  let qrcodetxt='/expertConfirmInfo?infoType=apply&accId='+that.accId+'&orgCode='+that.orgCode+'&planId='+that.planId+'&packageId='+that.packageId+'&id='+that.tableId+'&field='+obj.field;
                  let time = parseInt(new Date().getTime() / 1000);
                  obj.qrtext='http://'+this.domain+qrcodetxt+'&time='+time;
                  obj.showQrCode=true;
                  that.isSave=true;
                }
              }).finally(() => {
                that.confirmLoading = false;
              })

            }else{
              that.$message.error("信息填写不完整,请填写必填项，再生成二维码");
            }
          })

        }

      },
      add() {
        this.edit({});
      },
      edit(record)
      {
          let that=this;
        console.log("sqputong_chubuyanshou.showQrCodediv:"+this.sqputong_chubuyanshou.showQrCodediv+" genQcode:"+this.genQcode);
        if(record.isFuyan==1){
          this.fuyan.isFuyan=true;
          this.fuyan.title="复验申请";
        }
        else{
          this.fuyan.isFuyan=false;
          this.fuyan.title="验收申请";
        }
        this.form.resetFields();
        record.budgetAddmainCode=record.contractNo;
        this.model = Object.assign({}, record);
        if(this.model.createTime==undefined || this.model.createTime==null){
          this.model.createTime=moment().format('YYYY-MM-DD HH:mm:ss');
        }
        this.packageId = record.packageNo;
        //this.tableId = record.id;

        if(record.id!=null){
          this.accId=record.id;
        }
        else{
          this.accId='0';
        }

        this.contractTime=record.contractTime;
        this.tableId = record.packageNo;
        this.orgCode=record.sysOrgCode;
        this.planId=record.planId;
        // this.getdownload(record.shqdFile);
        this.hasBght=record.hasBght
        this.yssqEndTime=record.yssqEndTime
        this.projectType=record.projectType
        if(record.bgsqb!=''&&record.bgsqb != null){
          this.yscbgsq='1'
        }

        getAction("/uaps_budget_addmainmaster/uapsBudgetAddmainmaster/selectGZQianMsgTimeByTableId",{tableid:this.accId}).then((res)=>{
          this.dwfzrqzsj='';
          this.dwfzrqz='';
          res=res.data;
          if(res.success){
            if(res.result){
              var listmap = res.result;
              for(var i=0;i<listmap.length;i++){
                if (listmap[i].keyName=="lyyssh_xmzgdw"){
                  this.dwfzrqz=listmap[i].realname;
                  //this.dwfzrqzsj=formatDate(listmap[i].submitTime,'yyyy-MM-dd');
                    this.dwfzrqzsj = dayjs(listmap[i].submitTime).format('YYYY-MM-DD');
                }
              }
            }
          }else{
            that.$message.warning(res.message);
          }
        }).finally(() => {
          //that.confirmLoading = false;
        })
        this.getSign();
      },
      //获取基本信息
      GetQueryString(name)
      {
        var a = decodeURI(window.location.search)
        var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
        var r = a.substr(1).match(reg);
        if(r!=null)return unescape(r[2]); return null;
      },
      getDataById(){
        let packageId=this.GetQueryString("packageId");
        let planId=this.GetQueryString("planId");
        let id=this.GetQueryString("id");
        let accId=this.GetQueryString("accId");
        let sorgcode=this.GetQueryString("orgCode");
        if(this.genQcode==false && accId!=null){
          this.confirmLoading = true;
          getAction('/uaps_project_acceptance/uapsProjectAcceptance/queryProjectContent', {accId:accId,planId:planId,packageNo:packageId,orgCode:sorgcode}).then((res) => {
              res=res.data;
            if (res.success) {
              res.result.packageNo=packageId;
              if(accId=="0"){
                res.result.id=null;
              }
              this.confirmLoading = false;
              this.edit(res.result);
            }
            if (res.code === 510) {
              this.$message.warning(res.message)
            }
          })
        }
      },
      //获取手动上传签名
      getFlowSign(obj,name){
        let url="/uaps_project_acceptance/uapsProjectAcceptance/getSignByAccId";
        let params={accId:this.accId,title:this.flowTitle};
        obj.name.length=0;
        getAction(url, params).then((res) => {
          res=res.data;
          if (res.success) {
            if(res.result!=null && res.result.length>0){
              let records=res.result;
              for(let i=0;i<records.length;i++){
                if(records[i].name==name){
                  let sign={"name":records[i].name,"sign":records[i].Qian,"time":moment(records[i].submitTime).format('ll'),"GZ":records[i].GZ};
                  obj.name.push(sign);
                }

              }
              //判断是否已经签字 -1 为不限制签名个数
              if(obj.nameNum!=-1 && records.length>=obj.nameNum){
                obj.showQrCodediv=false;
              }
            }
          }
          if (res.code === 510) {
            this.$message.warning(res.message)
          }
        })
      },
      //获取签名信息
      getSign(){
        let url="/uaps_ele_signature/uapsEleSignature/listmobile";
        this.sqputong_jiandu.name.length=0;
        //工程监理意见
        let params={packageId:this.tableId,filedName:this.sqputong_jiandu.field,accId:this.accId};
        getAction(url, params).then((res) => {
          res=res.data;
          if (res.success) {
            if(res.result.records.length>0){
              let records=res.result.records;

              for(let i=0;i<records.length;i++){
                this.sqputong_jiandu.name.push(records[i].elSign);
                this.sqputong_jiandu.createTime=records[i].createTime;
                this.sqputong_jiandu.msg=records[i].msg;
                this.sqputong_jiandu.phone=records[i].phone;
                this.sqputong_jiandu.img.push({"elSign":records[i].elSign});

                // this.form.setFieldsValue({
                //   supervisionOpinions: records[i].msg,
                //   supervisorTelephone: records[i].phone,
                // })
                //监理已经签名，隐藏签名二维码
                this.sqputong_jiandu.showQrCodediv=false;
              }
              console.log(this.sqputong_jiandu);
            }
          }
          if (res.code === 510) {
            this.$message.warning(res.message)
          }
        })
        //初验人员(需三人)签字
        this.Sign(this.sqputong_chubuyanshou);
        //项目执行单位初步验收意见 项目负责人签字
        this.Sign(this.sqputong_chubuyanshouFuZheRen);
        //项目执行单位初步验收意见 单位负责人签字
        this.getFlowSign(this.sqputong_cyDanWeiFuZheRen,'项目主管单位审核');
      },
      Sign(obj){
        let url="/uaps_ele_signature/uapsEleSignature/listmobile";
        let params={projectId:this.tableId,filedName:obj.field,accId:this.accId,sysOrgCode:this.orgCode};
        obj.name.length=0;
        getAction(url, params).then((res) => {
          res=res.data;
          if (res.success) {
            if(res.result.records.length>0){
              let records=res.result.records;
              for(let i=0;i<records.length;i++){
                let imgBase64=records[i].elSign;
                obj.name.push(imgBase64);
                obj.createTime=moment(records[i].createTime).format('ll');
                obj.phone=records[i].phone;
                obj.msg=records[i].msg;
                obj.img.push(records[i]);

              }

              //判断是否已经签字 -1 为不限制签名个数
              if(obj.nameNum!=-1 && records.length>=obj.nameNum){
                obj.showQrCodediv=false;
              }
            }
            else{
              obj.showQrCodediv=true;
              obj.name.length=0;
              obj.createTime="";
              obj.phone="";
              obj.msg="";
              obj.img.length=0;
            }
          }
          if (res.code === 510) {
            this.$message.warning(res.message)
          }
        })
      },
      //判断是否签字
      qz(data){
        if(data.nameNum==-1){
          if(data.name.length==0){
            this.$message.error(data.qrtitle+"不完整");
            return false;
          }
        }
        else{
          if(data.name.length!=data.nameNum){
            this.$message.error(data.qrtitle+"不完整,需要"+data.nameNum+"人签字");
            return false;
          }
        }
        return true;
      },
      checkSign(){
        let gcjl=null;
        if(this.projectType=='工程'){
          //工程监理签字
          gcjl=this.qz(this.sqputong_jiandu);
        }

        //初步验收成员签字
        let cbysChenyuan=this.qz(this.sqputong_chubuyanshou);

        //初步验收项目负责人签字
        let cbysxmFuZheRen=this.qz(this.sqputong_chubuyanshouFuZheRen);

        //初步验收项目单位负责人签字
        //let cbysdwFuZheRen=this.qz(this.sqputong_cyDanWeiFuZheRen);
        let cbysdwFuZheRen=true;
        if(this.confirmLoading){
          this.confirmLoading = false;
        }
        if((gcjl==null || gcjl) && cbysChenyuan && cbysxmFuZheRen && cbysdwFuZheRen){
          return true;
        }
        return false;

        // let jlqz=this.sqputong_jiandu;
        // if(jlqz.name.length!=jlqz.nameNum){
        //   this.$message.error("工程监理签字不完整");
        //   return false;
        // }
        //
        // let cyqz=this.sqputong_chubuyanshou;
        // if(cyqz.name.length!=cyqz.nameNum){
        //   this.$message.error("项目执行单位初步验收意见，初验人员签字不完整");
        //   return false;
        // }
        //
        // let cyfzrqz=this.sqputong_chubuyanshouFuZheRen;
        // if(cyfzrqz.name.length!=cyfzrqz.nameNum){
        //   this.$message.error("项目执行单位初步验收意见，项目负责人签字不完整");
        //   return false;
        // }
        //
        // let cydwqz=this.sqputong_cyDanWeiFuZheRen;
        // if(cydwqz.name.length!=cydwqz.nameNum){
        //   this.$message.error("项目执行单位初步验收意见，单位负责人签字不完整");
        //   return false;
        // }
        // return true;
      },
      //渲染流程表单数据
      showFlowData() {
        if (this.formBpm === true) {
          let params = {id: this.formData.dataId};
          getAction(this.url.queryById, params).then((res) => {
            if (res.success) {
              this.edit(res.result);
            }
          });
        }
      },
      submitForm() {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            var datee = new Date();
            var projectFinishtime = Date.parse(values.projectFinishtime);
            if(datee<=projectFinishtime){
              this.$message.error("完工日期不能超过当天时间");
              return;
            }
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            httpurl += that.url.add;
            method = 'post';
            let formData = Object.assign(that.model, values);
            formData.packageNo = that.packageId;
            formData.isBa='0'
             if(formData.ysxzIdea=="2" || formData.ysxzIdea=="3"){
               formData.ysxzIdea=null;
               formData.createTime=null;
               formData.ysxzObjection=null;
             }
             formData.id=that.accId;
             httpAction(httpurl, formData, method).then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.$emit('ok');
                } else {
                  let msg=res.message;
                  let msgArray=msg.split(',');
                  that.accId=msgArray[1];
                  that.$message.error(msgArray[0]);
                }
              }).finally(() => {
                that.confirmLoading = false;
              })

          }else{
            that.$message.error("信息填写不完整,请核对必填项");
          }
        })
      },
      removeImg(id){
        var that=this;
        deleteAction('/uaps_ele_signature/uapsEleSignature/deletemobile', {id: id}).then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            this.sqputong_jiandu={
              name:[],
                nameNum:1,//签名个数
                msg:"",
                phone:"",
                yijian:"",
                qrtitle:"工程监理意见签字",
                qrtext:"",
                field:"sqputong_jiandu",
                showQrCodediv:true,
                showQrCode:false,
                createTime:null,
                img:[]
            }
            //项目执行单位初步验收意见 初验人员(需三人)签字
            this.sqputong_chubuyanshou={
              name:[],
                nameNum:3,//签名个数
                phone:"",
                msg:"",
                qrtitle:"初验人员签字",
                qrtext:"",
                field:"sqputong_chuyan",
                showQrCodediv:true,
                showQrCode:false,
                createTime:null,
                img:[]
            }
            //项目执行单位初步验收意见 项目负责人签字
            this.sqputong_chubuyanshouFuZheRen={
              name:[],
                nameNum:1,//签名个数
                phone:"",
                msg:"",
                qrtitle:"项目负责人签字",
                qrtext:"",
                field:"sqputong_chuyanFuZheRen",
                showQrCodediv:true,
                showQrCode:false,
                createTime:null,
                img:[]
            }
            //项目执行单位初步验收意见 单位负责人签字
            this.sqputong_cyDanWeiFuZheRen={
              name:[],
                nameNum:1,//签名个数
                phone:"",
                msg:"",
                qrtitle:"单位负责人签字",
                qrtext:"",
                field:"sqputong_chuyanDanWeiFuZheRen",
                showQrCodediv:false,
                //showQrCodediv:true,
                showQrCode:false,
                createTime:null,
                img:[]
            }
            that.getSign();

          } else {
            that.$message.warning(res.message);
          }
        });
      },
      popupCallback(row) {
        this.form.setFieldsValue(pick(row, 'budgetYear', 'financeProject', 'budgetDeclaretype', 'projectScope', 'gcType', 'isImport', 'budgetAddmainName', 'budgetAddmainAmount', 'contactName', 'contactPhone', 'budgetAddmainRemark', 'budgetShSchool', 'budgetSpZcb', 'budgetSpCaiwu', 'budgetSpGov', 'budgetMainAmountpifu', 'budgetBuyType', 'budgetAgencyCompanyid', 'budgetAgencyCompany', 'processId', 'limitTime', 'safeTime', 'parameterFile', 'parameterContent', 'isInplan', 'planId', 'backReason', 'isCslz', 'masterId', 'agreementBTime', 'agreementETime'))
      },
      getdownload(fileIds) {
        if (fileIds != "" && fileIds != null) {
          let sqsjData = JSON.parse(fileIds);
          this.fileIds = [];
          for (let i = 0; i < sqsjData.length; i++) {
            this.fileIds.push(sqsjData[i]);
          }
        }
      },
      download(fileName, id) {
        downloadFile('/file/download/', fileName, {fileId: id});
      },
      deleteAction(id) {
        this.fileIds.splice(this.fileIds.findIndex(e => e.fileid == id), 1)
      },
    }
  }
</script>
<style>
  @font-face {
    font-family: "Times New Roman";
  }

  @font-face {
    font-family: "宋体";
  }

  @font-face {
    font-family: "Wingdings";
  }

  @font-face {
    font-family: "黑体";
  }

  @font-face {
    font-family: "Arial";
  }

  @font-face {
    font-family: "方正小标宋简体";
  }

  p.MsoNormal {
    mso-style-name: 正文;
    mso-style-parent: "";
    margin: 0pt;
    margin-bottom: .0001pt;
    mso-pagination: none;
    text-align: justify;
    text-justify: inter-ideograph;
    font-family: 'Times New Roman';
    mso-fareast-font-family: 宋体;
    font-size: 10.5000pt;
    mso-font-kerning: 1.0000pt;
  }

  span

  .10
  {
    font-family: 'Times New Roman'
  ;
  }

  span

  .15
  {
    font-family: 'Times New Roman'
  ;
    font-size: 9.0000pt
  ;
    mso-font-kerning: 1.0000pt
  ;
  }

  span

  .16
  {
    font-family: 'Times New Roman'
  ;
    font-size: 9.0000pt
  ;
    mso-font-kerning: 1.0000pt
  ;
  }

  p.MsoAcetate {
    mso-style-name: 批注框文本;
    mso-style-noshow: yes;
    margin: 0pt;
    margin-bottom: .0001pt;
    mso-pagination: none;
    text-align: justify;
    text-justify: inter-ideograph;
    font-family: 'Times New Roman';
    mso-fareast-font-family: 宋体;
    font-size: 9.0000pt;
    mso-font-kerning: 1.0000pt;
  }

  p.MsoFooter {
    mso-style-name: 页脚;
    margin: 0pt;
    margin-bottom: .0001pt;
    layout-grid-mode: char;
    mso-pagination: none;
    text-align: left;
    font-family: 'Times New Roman';
    mso-fareast-font-family: 宋体;
    font-size: 9.0000pt;
    mso-font-kerning: 1.0000pt;
  }

  p.MsoHeader {
    mso-style-name: 页眉;
    margin: 0pt;
    margin-bottom: .0001pt;
    border-bottom: 1.0000pt solid windowtext;
    mso-border-bottom-alt: 0.7500pt solid windowtext;
    padding: 0pt 0pt 1pt 0pt;
    layout-grid-mode: char;
    mso-pagination: none;
    text-align: center;
    font-family: 'Times New Roman';
    mso-fareast-font-family: 宋体;
    font-size: 9.0000pt;
    mso-font-kerning: 1.0000pt;
  }

  span.msoIns {
    mso-style-type: export-only;
    mso-style-name: "";
    text-decoration: underline;
    text-underline: single;
    color: blue;
  }

  span.msoDel {
    mso-style-type: export-only;
    mso-style-name: "";
    text-decoration: line-through;
    color: red;
  }
  .image-container {
    position: relative;
    display: inline-block;
  }

  .delete-button {
    display: none;
    position: absolute;
    top: 5px;
    right: 5px;
    background-color: #cacaca;
    color: #000000;
    font-size: 12px;
    padding: 5px;
    cursor: pointer;
    user-select: none;
  }

  .image-container:hover .delete-button {
    display: block;
  }
  table.MsoNormalTable {
    mso-style-name: 普通表格;
    mso-style-parent: "";
    mso-style-noshow: yes;
    mso-tstyle-rowband-size: 0;
    mso-tstyle-colband-size: 0;
    mso-padding-alt: 0.0000pt 5.4000pt 0.0000pt 5.4000pt;
    mso-para-margin: 0pt;
    mso-para-margin-bottom: .0001pt;
    mso-pagination: widow-orphan;
    font-family: 'Times New Roman';
    font-size: 10.0000pt;
    mso-ansi-language: #0400;
    mso-fareast-language: #0400;
    mso-bidi-language: #0400;
  }

  @page {
    mso-page-border-surround-header: no;
    mso-page-border-surround-footer: no;
  }

  @page Section0 {
    margin-top: 72.0000pt;
    margin-bottom: 72.0000pt;
    margin-left: 90.0000pt;
    margin-right: 90.0000pt;
    size: 595.3000pt 841.9000pt;
    layout-grid: 15.6000pt;
    mso-header-margin: 42.5500pt;
    mso-footer-margin: 49.6000pt;
  }

  .shurukuang{
    border: none !important;
    resize:none;
    text-align: center;
    background-color: #FFFFFF;
  }
  .ant-input-disabled {
    background-color: #fff !important;
    color: #000 !important;
  }

</style>
